import React from "react";
import { Table, TableContainer } from "@mui/material";
import BarcodesTableHeader from "./BarcodesTableHeader";
import BarcodesTableBody from "./BarcodesTableBody";

const BarcodesTable = ({ ...rest }) => {
  return (
    <TableContainer>
      <Table>
        <BarcodesTableHeader />
        <BarcodesTableBody {...rest} />
      </Table>
    </TableContainer>
  );
};

export default BarcodesTable;
